import React from 'react'
import MemberBox from './MemberBox'

const ContactPage = () => {
  return (
    <div className='home-body'>
        <div className="top-body">
            <h1>Contact the BlueLoops!</h1>
            <p>Here are the various members and co-ordinators of the BlueLoop Association. Contact them for more Information! There are many Titles and Positions inside BlueLoop Association as there are many Start-Ups and Business blooming inside this wonderful and perfect Community for all the aspiring Entreprenuers</p>
        </div>
        <div className="content">
            <MemberBox/>
        </div>
            
    </div>
  )
}

export default ContactPage